export default {
  vehicleGroups: [],
  selectedVehicleGroup: undefined,
  vehicleGroupLicensePlates: []
}
